module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.ede02f48.ttf";